"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePositionCashFlowSummary = void 0;
const react_1 = require("react");
const interface_1 = require("./../../../interface");
const utils_1 = require("./../../../utils");
const trade_utils_lib_1 = require("trade_utils_lib");
function usePositionCashFlowSummary({ feeMap, loading, $num, precision, }) {
    const format = (0, react_1.useCallback)((fee) => {
        var _a;
        if (fee === undefined) {
            return [new trade_utils_lib_1.SafeDecimal(0), "0"];
        }
        const feeD = new trade_utils_lib_1.SafeDecimal(fee).toDP((_a = (0, utils_1.getPnlPrecision)(fee, precision)) !== null && _a !== void 0 ? _a : 2, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
        return [
            feeD,
            $num(feeD, {
                precision: "default",
            }),
        ];
    }, [$num, precision]);
    const [positionSettlement, positionSettlementDisplay] = (0, react_1.useMemo)(() => {
        if (loading) {
            return [new trade_utils_lib_1.SafeDecimal(0), "--"];
        }
        const fee = feeMap.get(interface_1.FuturesCashflowType.POSITION_SETTLEMENT);
        return format(fee);
    }, [feeMap, format, loading]);
    const [fundingFee, fundingFeeDisplay] = (0, react_1.useMemo)(() => {
        if (loading) {
            return [new trade_utils_lib_1.SafeDecimal(0), "--"];
        }
        const fee = feeMap.get(interface_1.FuturesCashflowType.FUNDING_FEE);
        return format(fee);
    }, [feeMap, format, loading]);
    const [totalTradingFee, totalTradingFeeDisplay, originTotalTradingFee] = (0, react_1.useMemo)(() => {
        var _a;
        if (loading) {
            return [new trade_utils_lib_1.SafeDecimal(0), "--", new trade_utils_lib_1.SafeDecimal(0)];
        }
        const tradingFee = feeMap.get(interface_1.FuturesCashflowType.TRADING_FEE);
        const delistingFee = feeMap.get(interface_1.FuturesCashflowType.DELISTING_FEE);
        const liquidationFee = feeMap.get(interface_1.FuturesCashflowType.LIQUIDATION_FEE);
        const remedy = feeMap.get(interface_1.FuturesCashflowType.REMEDY);
        let originTFee = new trade_utils_lib_1.SafeDecimal(tradingFee)
            .add(new trade_utils_lib_1.SafeDecimal(delistingFee))
            .add(new trade_utils_lib_1.SafeDecimal(liquidationFee))
            .add(new trade_utils_lib_1.SafeDecimal(remedy));
        const tFee = originTFee.toDP((_a = (0, utils_1.getPnlPrecision)(originTFee, precision)) !== null && _a !== void 0 ? _a : 2, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
        return [
            tFee,
            $num(tFee, {
                precision: "default",
            }),
            originTFee,
        ];
    }, [$num, feeMap, loading, precision]);
    const [pnl, pnlDisplay] = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        if (loading) {
            return [new trade_utils_lib_1.SafeDecimal(0), "--"];
        }
        let pnlD = new trade_utils_lib_1.SafeDecimal((_a = feeMap.get(interface_1.FuturesCashflowType.POSITION_SETTLEMENT)) !== null && _a !== void 0 ? _a : 0)
            .add((_b = feeMap.get(interface_1.FuturesCashflowType.FUNDING_FEE)) !== null && _b !== void 0 ? _b : 0)
            .add(originTotalTradingFee);
        pnlD = pnlD.toDP((_c = (0, utils_1.getPnlPrecision)(pnlD, precision)) !== null && _c !== void 0 ? _c : 2, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
        return [
            pnlD,
            $num(pnlD, {
                precision: "default",
            }),
        ];
    }, [$num, loading, precision, originTotalTradingFee, feeMap]);
    return (0, react_1.useMemo)(() => {
        return {
            feeMap,
            positionSettlement,
            positionSettlementDisplay,
            fundingFee,
            fundingFeeDisplay,
            totalTradingFee,
            totalTradingFeeDisplay,
            pnl,
            pnlDisplay,
        };
    }, [
        feeMap,
        fundingFee,
        fundingFeeDisplay,
        pnl,
        pnlDisplay,
        positionSettlement,
        positionSettlementDisplay,
        totalTradingFee,
        totalTradingFeeDisplay,
    ]);
}
exports.usePositionCashFlowSummary = usePositionCashFlowSummary;
